// extracted by mini-css-extract-plugin
export default {"butn":"sidenavbtn_butn__E4nR8","icons":"sidenavbtn_icons__Hxp0X","title":"sidenavbtn_title__PXy4R","titlenone":"sidenavbtn_titlenone__8uvxX"};